<template>

    <m-edit1/>

    <m-verify-cellphone-1 v-bind='{...{},...{}}' :style='""' class="" ></m-verify-cellphone-1>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mVerifyCellphone1 from '@moeinmdn/miw-alpha-components/src/package/Authentication/VerifyCellPhone/VerifyCellphone1';

export default {
    name: 'HomeView',
    components: {mEdit1, mVerifyCellphone1 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
